import { useEffect, useState } from "react";
import { Table } from "@app/dashboard/src/components/shared";
import { BiuDetectorRow } from "./BiuDetectorRow";
import { BiuDataMap, BiuDetectorRowData, BiuNumber, DETECTOR_NUMBERS } from "./types";

type BiuDetectorTableProps = {
    biuNum: BiuNumber;
    data: BiuDataMap;
    organizationId: string;
    facilityId?: string;
    luxcomEndpointId?: string;
    onSave: (data: BiuDetectorRowData, isNew: boolean) => Promise<void>;
    onDelete: (data: BiuDetectorRowData) => Promise<void>;
    offlineMode?: boolean;
};

export const BiuDetectorTable: React.FC<BiuDetectorTableProps> = ({ biuNum, data, organizationId, facilityId, luxcomEndpointId, onSave, onDelete, offlineMode }) => {
    const biuData = data[biuNum] || {};
    const [expandedDetector, setExpandedDetector] = useState<number | null>(null);

    useEffect(() => {
        setExpandedDetector(null);
    }, [biuNum]);

    const handleExpandChange = (detectorNum: number, isExpanded: boolean) => {
        setExpandedDetector(isExpanded ? detectorNum : null);
    };

    return (
        <div className="border border-gray-200 rounded-lg overflow-hidden">
            <Table.Container className="w-full">
                <Table.Header>
                    <Table.HeaderRow className="bg-gray-100">
                        <Table.HeaderCol className="w-6 px-4 py-3" />
                        <Table.HeaderCol className="w-16 px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Det #</Table.HeaderCol>
                        <Table.HeaderCol className="flex-1 px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <div className={offlineMode ? "grid grid-cols-4 gap-2" : "grid grid-cols-5 gap-2"}>
                                <div>Expression</div>
                                <div>Trigger Type</div>
                                <div>DZ/SL Filter</div>
                                {!offlineMode && <div>Device</div>}
                                <div>Targets</div>
                            </div>
                        </Table.HeaderCol>
                        <Table.HeaderCol className="w-12 px-2 py-3" />
                    </Table.HeaderRow>
                </Table.Header>
            </Table.Container>

            <div className="divide-y divide-gray-200">
                {DETECTOR_NUMBERS.map((detectorNum) => (
                    <BiuDetectorRow key={detectorNum} biuNum={biuNum} detectorNum={detectorNum} configurations={biuData[detectorNum] || []} organizationId={organizationId} facilityId={facilityId} luxcomEndpointId={luxcomEndpointId} onSave={onSave} onDelete={onDelete} isExpanded={expandedDetector === detectorNum} onExpandChange={(isExpanded) => handleExpandChange(detectorNum, isExpanded)} offlineMode={offlineMode} />
                ))}
            </div>
        </div>
    );
};
